import ScreenCheckIn from './ScreenCheckIn/ScreenCheckIn';

export default ScreenCheckIn;
